module.exports = __webpack_public_path__ + "img/angular.f26e178e.svg";